export class Catalogazione {
  _id: string;
  codice: string;
  label: string;
  parent: string;
  parentLabel: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Catalogazione.ts